// Types
export type {Dictionary, Locale, TranslateFunction} from "./types";
export {defaultLocale, isLocale, locales} from "./types";

// Client-side
export {I18nProvider, useI18nContext} from "./i18n-provider";
export {useTranslation} from "./use-translation";

// Utilities (can be used on both client and server)
export {createTranslator, Translator} from "./translator";
export {getNestedValue, interpolate} from "./interpolate";
export {WEEKDAY_TO_KEY_MAP, MONTH_SHORT_TO_KEY_MAP, MONTH_FULL_TO_KEY_MAP, getWeekdayTranslationKey, getMonthTranslationKey} from "./utils";

// NOTE: For server-side imports use:
// import { getDictionary } from "@/shared/lib/i18n/server";
